export default __webpack_public_path__ + "static/media/Logo.3709cd52.png";